import { VOCABULARY_SCHEMA_VERSION } from "../../../domain/vocabulary/types.ts";
import { vocabularySnapshotV1Schema } from "../versions/v1.ts";
import { vocabularySnapshotV2Schema } from "../versions/v2.ts";
import { vocabularySnapshotV3Schema } from "../versions/v3.ts";
import { v1ToV2Step } from "./steps/v1-to-v2.ts";
import { v2ToV3Step } from "./steps/v2-to-v3.ts";
import { createMigrationRegistry, MigrationRegistryError } from "./registry.ts";

if (VOCABULARY_SCHEMA_VERSION !== 3) {
  throw new MigrationRegistryError(
    "Production storage registry must match VOCABULARY_SCHEMA_VERSION. Register a migration before bumping the domain version.",
  );
}

export const productionRegistry = createMigrationRegistry({
  currentVersion: 3,
  schemas: [
    { version: 1, schema: vocabularySnapshotV1Schema },
    { version: 2, schema: vocabularySnapshotV2Schema },
    { version: 3, schema: vocabularySnapshotV3Schema },
  ],
  steps: [v1ToV2Step, v2ToV3Step],
});
